<template>
  <div class="controls-wrapper">
    <icon-button icon="el-icon-close" v-if="leftControl" @click="removePrice"/>
    <icon-button icon="el-icon-edit"  v-else @click="showDialog = true" />
    <el-dialog :append-to-body="true" append-to-body v-if="!leftControl && showDialog" width="400px" title="Edit price" :visible.sync="showDialog">
      <upsert-form
        v-if="showDialog"
        :price="extendedPrice"
        :stations="organization.stations"
        :groups="organization.groups || []"
        :users="users"
        @updated="updated"
        editing />
    </el-dialog>
  </div>
</template>

<script>
import UpsertForm from './UpsertForm'

export default {
  name: 'PricingControls',
  components: { UpsertForm },
  props: {
    organization: {
      type: Object,
      required: false
    },
    price: {
      type: Object,
      required: true
    },
    leftControl: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  computed: {
    extendedPrice () {
      return {
        gasTypeId: this.price.gasType.id,
        stationIds: this.price.station ? [this.price.station.id] : [],
        userIds: this.price.user ? [this.price.user.id] : [],
        groupIds: this.price.group ? [this.price.group.id] : [],
        ...this.price
      }
    },
    users () {
      return this.organization.users.map(user => {
        return user.user
      })
    }
  },
  methods: {
    updated (price) {
      this.$emit('updated', price)
      this.showDialog = false
    },
    removePrice () {
      this.confirmAndremovePrice()
    },
    async confirmAndremovePrice () {
      try {
        await this.$confirm('Are you sure?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'Warning'
        })
      
        const response = await this.$http.delete(this.$api.organization(this.$route.params.orgId).gasPrice(this.price.id).remove)
        this.$message.success('Price removed successfully')
        this.$emit('removed', this.price)
      } catch (e) {}
    }
  }
}
</script>

<style scoped>
  .controls-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Pricing/PricingControls.vue